import { Reset } from "@mosanic/auth";
import { useRouter } from "next/router";

const ResetPage = ({}) => {
  const query = useRouter()?.query;

  return (
    <Reset accountActions  resetCode={query?.resetCode || query?.reset}/>
  );
}
export default ResetPage;
